export const NEVER_USED_TEXT = "No user has accessed this table";
